<script setup lang="ts">
import { reactive, watch, ref } from 'vue';
import i18n from '@/lang/i18n';

const props = defineProps<{
  telephoneNumber: string;
  faxNumber: string;
  errors: { telephone_number: string; fax_number: string };
}>();
const emit = defineEmits(['inputValue']);
const telephone = ref('');
const fax = ref('');
const data = reactive({ telephone_number: '', fax_number: '' });
const unwatchTelephone = watch(
  () => props.telephoneNumber,
  (propsTelephoneNumber) => {
    telephone.value = propsTelephoneNumber;
    unwatchTelephone();
  }
);
const unwatchFax = watch(
  () => props.faxNumber,
  (propsFaxNumber) => {
    fax.value = propsFaxNumber;
    unwatchFax();
  }
);

watch(telephone, () => {
  data.telephone_number = telephone.value;
  emit('inputValue', data);
});
watch(fax, () => {
  data.fax_number = fax.value;
  emit('inputValue', data);
});
</script>
<template>
  <v-row class="text-form pl-4 pr-3 mb-3">
    <v-col cols="2">
      <h6 class="pl-4 align-center">
        {{ i18n.global.t('pages.operationOffices.telephoneNumber') }}
      </h6>
    </v-col>
    <v-col cols="4">
      <v-text-field
        v-model="telephone"
        maxlength="11"
        :error-messages="errors.telephone_number"
      />
    </v-col>
    <v-col cols="2">
      <h6 class="pl-4 align-center">
        {{ i18n.global.t('pages.operationOffices.form.fax') }}
      </h6>
    </v-col>
    <v-col cols="4">
      <v-text-field
        v-model="fax"
        maxlength="11"
        :error-messages="errors.fax_number"
      />
    </v-col>
  </v-row>
</template>
